const RESET_STORE = 'adRecordingModalScreen/RESET_STORE';
const SET_CAMPAIGN_ID = 'adRecordingModalScreen/SET_CAMPAIGN_ID';
const SET_AD_AUDIO = 'adRecordingModalScreen/SET_AD_AUDIO';
const SET_IS_SHOWING = 'adRecordingModalScreen/SET_IS_SHOWING';
const SET_IS_HOUSE_AD = 'adRecordingModalScreen/SET_IS_HOUSE_AD';
const SET_IS_MIDROLL_REQUIRED =
  'adRecordingModalScreen/SET_IS_MIDROLL_REQUIRED';
const SET_AD_DETAILS = 'adRecordingModalScreen/SET_AD_DETAILS';
const SET_IS_ANCHOR_PAYMENTS_ACTIVATED =
  'adRecordingModalScreen/IS_ANCHOR_PAYMENTS_ACTIVATED';
const SET_AD_SCRIPT = 'adRecordingModalScreen/SET_AD_SCRIPT';
const SET_CURRENT_TAB = 'adRecordingModalScreen/SET_CURRENT_TAB';
const SET_COMPANY_URL = 'adRecordingModalScreen/SET_COMPANY_URL';
const SET_RPM_IN_CENTS = 'adRecordingModalScreen/SET_RPM_IN_CENTS';
const SET_COMPANY_NAME = 'adRecordingModalScreen/SET_COMPANY_NAME';
const SET_IS_PLAYING_AD = 'adRecordingModalScreen/SET_IS_PLAYING_AD';
const SET_EXAMPLE_AD_AUDIO_URL =
  'adRecordingModalScreen/SET_EXAMPLE_AD_AUDIO_URL';
const SET_IS_PLAYING_EXAMPLE_AD =
  'adRecordingModalScreen/SET_IS_PLAYING_EXAMPLE_AD';

const SET_IS_SHOWING_RECORD_AGAIN_CONFIRMATION_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_RECORD_AGAIN_CONFIRMATION_OVERLAY';
const SET_IS_SHOWING_SUBMISSION_PROGRESS_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_SUBMISSION_PROGRESS_OVERLAY';
const SET_IS_SHOWING_NOT_INTERESTED_CONFIRMATION_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_NOT_INTERESTED_CONFIRMATION_OVERLAY';
const SET_IS_SHOWING_SUCCESS_CONFIRMATION_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_SUCCESS_CONFIRMATION_OVERLAY';
const SET_IS_SHOWING_SUCCESS_CONFIRMATION_WITH_ALL_EPISODES_ACTIVATION_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_SUCCESS_CONFIRMATION_WITH_ALL_EPISODES_ACTIVATION_OVERLAY';
const SET_IS_SHOWING_MIDROLL_REQUIREMENT_OVERLAY =
  'adRecordingModalScreen/SET_IS_SHOWING_MIDROLL_REQUIREMENT_OVERLAY';

export default {
  RESET_STORE,
  SET_AD_SCRIPT,
  SET_CAMPAIGN_ID,
  SET_AD_AUDIO,
  SET_CURRENT_TAB,
  SET_AD_DETAILS,
  SET_IS_ANCHOR_PAYMENTS_ACTIVATED,
  SET_IS_SHOWING,
  SET_IS_HOUSE_AD,
  SET_IS_MIDROLL_REQUIRED,
  SET_COMPANY_URL,
  SET_RPM_IN_CENTS,
  SET_COMPANY_NAME,
  SET_IS_PLAYING_AD,
  SET_EXAMPLE_AD_AUDIO_URL,
  SET_IS_PLAYING_EXAMPLE_AD,
  SET_IS_SHOWING_RECORD_AGAIN_CONFIRMATION_OVERLAY,
  SET_IS_SHOWING_SUBMISSION_PROGRESS_OVERLAY,
  SET_IS_SHOWING_NOT_INTERESTED_CONFIRMATION_OVERLAY,
  SET_IS_SHOWING_SUCCESS_CONFIRMATION_OVERLAY,
  SET_IS_SHOWING_SUCCESS_CONFIRMATION_WITH_ALL_EPISODES_ACTIVATION_OVERLAY,
  SET_IS_SHOWING_MIDROLL_REQUIREMENT_OVERLAY,
};
